import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const Blogs = () => {

    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0)

        const getBlogs = async () => {
            try {
                const data = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getblogs?limit=2`);
                const array = data.data;
                setBlogs(array);
                console.log(array);

            } catch (err) {
                console.log(err);
            }
        }

        getBlogs();
    }, [])

    return (
        <div className="relative w-full bigscreen p-16 mt-20">

            <div className='font-semibold text-[28px] text-center mb-12'>
                Explore Our Blogs
            </div>

            <div className='grid grid-cols-2 gap-16 justify-center my-4'>

                {blogs?.length > 0 ?
                    blogs?.map(blog => (
                        <Link to={`/blogs`} key={blog?._id}>
                            <div className='blogBox'>
                                <div className='blogImg'>
                                    <img src={blog?.image} />
                                </div>
                                <div className='blogContent'>
                                    <div className='blogTime'>
                                        Posted {blog?.createdAt && new Date(blog.createdAt).toLocaleDateString()}
                                    </div>
                                    <div className='blogHead'>
                                        {blog?.title}
                                    </div>
                                    <div className='blogText'>
                                        {blog?.paragraphs &&
                                            blog?.paragraphs[0]}
                                    </div>
                                </div>
                            </div>
                        </Link>
                    ))

                    :
                    <div>no blogs to show</div>
                }


            </div>
        </div>
    )
}

export default Blogs